exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wrapper {\n    padding: 0 18px;\n    margin: 20px 0 auto;\n    text-align: center;\n    font-style: italic;\n    color: #175e7e;\n}\n\n.wrapper > h1 {\n    font-size: 20px;\n    font-weight: bold;\n    color: #175e7e;\n}\n\n.wrapper > h2 {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 22px;\n    text-transform: uppercase;\n    color: #ab0f27;\n    text-decoration: underline;\n}\n\n.wrapper > p {\n    font-style: normal;\n    font-weight: bold;\n    font-size: 20px;\n}\n\n.wrapper > p > span.bigger {\n    display: inline-block;\n    font-size: 22px;\n}\n\n.wrapper > hr {\n    border: none;\n    color: #175e7e;\n    background-color: #175e7e;\n    height: 2px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./frontend/src/modules/ContentPlaceholder/style.css
// module id = 1404
// module chunks = 0